import PageWrapper from "../../layout/PageWrapper";
import HomeMobile from "./HomeMobile/HomeMobile";
import HomePc from "./HomePc/HomePc";

export default () => <PageWrapper PagePc={HomePc} PageMobile={HomeMobile} />;
